export default "__VITE_ASSET__CcStZCUU__"